import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { removeExistingSessionData } from "../lib/helper";

const Callback = () => {
  const navigate = useNavigate();
  const codeVerifier = localStorage.getItem("verifier");
  const ref = localStorage.getItem("ref");
  const hasRun = useRef(false);
  // useEffect(() => {
  //   getToken();
  // }, [codeVerifier]);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true; // Mark as executed
      getToken();
    }
  }, [codeVerifier]); // Runs only once
  const getToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
    localStorage.setItem('code',code)
    }
    if(ref === 'login'){
      
        const requestBody = new URLSearchParams({
          client_id: process.env.REACT_APP_CLIENT_ID,
          grant_type: "authorization_code",
          code: code,
          redirect_uri: process.env.REACT_APP_REDIRECT_URI,
          code_verifier: codeVerifier,
        });
  
        axios
          .post(`https://app.meldrx.com/connect/token`, requestBody, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then(async(response) => {
            if (response) {
              await  getUserDetails(response?.data?.access_token)
              localStorage.setItem(
                "access_token",
                JSON.stringify(response?.data?.access_token)
              );
              localStorage.setItem("patient_id", response?.data?.patient);
              checkValidUser(response?.data?.access_token);
              {
                removeExistingSessionData();
              //  if(ref == 'qr'){
              //   navigate("/qr");
              //  }
                  // else{
                  //   navigate("/voice");
                  // }
                  navigate("/voice");
              }
            }
          })
  
          .catch((error) => console.error("Error fetching token:", error));
      
    }
    else{
      navigate('/qr')
    }
   
  };

  const getUserDetails = async (token) => {
    if (!token) {
      console.error("Token is required.");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_MELDRX_BASE_URL}/connect/userinfo`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        localStorage.setItem("user_name", response?.data?.name);
        localStorage.setItem(
          "preferred_username",
          response?.data?.preferred_username
        );
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error(
        "Error fetching user info:",
        error?.response?.data || error.message
      );
    }
  };

  const checkValidUser = async (token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/react-patient?token=${token}`
      );
      if (response) {
        console.log("response", response);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Data:", error.response.data);

        if (error.response.status === 403) {
          navigate("/forbidden"); // Redirect to the forbidden page
        }
      }
    }
  };
  return (
    <></>
    // <div>
    //   <p>Processing your login...</p>
    // </div>
  );
};

export default Callback;
